/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpdatePromoBannerDto = {
  placement?: UpdatePromoBannerDto.placement;
  categoryId?: string;
  platform?: UpdatePromoBannerDto.platform;
  linkType?: UpdatePromoBannerDto.linkType;
  targetId?: string;
  imageUrl?: string;
  isActive?: boolean;
};
export namespace UpdatePromoBannerDto {
  export enum placement {
    HOME = "HOME",
    EXPLORE_CATEGORY = "EXPLORE_CATEGORY",
    MY_PAGE = "MY_PAGE",
  }
  export enum platform {
    APP = "APP",
    WEB = "WEB",
    ALL = "ALL",
  }
  export enum linkType {
    QUIZ_PACK = "quizPack",
    CURRICULUM = "curriculum",
    EXPLORE_TOURNAMENT = "exploreTournament",
    BATTLE = "battle",
    TOURNAMENT = "tournament",
    VOCAB = "vocab",
    URL = "url",
  }
}
